import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import ImageUpload from '../../ImageUpload';
import TextBlock from '../../TextBlock';

import Wrapper from './Wrapper';
import Img from './Img';
import ImageText from './ImageText';

class Image extends React.PureComponent {
  handleDescriptionChange = (value) => {
    this.props.onChangeBlockField(value, 'description');
  }

  render() {
    const image = this.props.block.get('image');

    return (
      <Wrapper>
        {!this.props.block.get('uploading') && (
          <React.Fragment>
            {image ? (
              <Img src={image.get('path')} onButtonClick={this.props.onRemoveMedia} />
            ) : (
              <ImageUpload
                titles={{
                  uploadDialog: <div>Загрузить <br /> с компьютера</div>,
                  drag: <div>Перетащите сюда <br /> изображение</div>,
                }}
                onDropFile={this.props.onDropFile}
              />
            )}

            <ImageText>
              <TextBlock
                block={this.props.block}
                fieldName="description"
                placeholder="Добавьте описание к изображению"
                onChange={this.handleDescriptionChange}
              />
            </ImageText>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

Image.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,

  onChangeBlockField: PropTypes.func,
  onRemoveMedia: PropTypes.func,
  onDropFile: PropTypes.func,
};

Image.defaultProps = {
  onChangeBlockField: () => {},
  onRemoveMedia: () => {},
  onDropFile: () => {},
};

export default Image;
